import { inject, Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";

import { MessageDialogComponent } from "~/containers/dialogs/message-dialog/message-dialog.component";
import { CompanyService } from "~/core/services/company.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class ErrorInterceptor implements HttpInterceptor {
  translateService: TranslateService = inject(TranslateService);
  companyService: CompanyService = inject(CompanyService);
  isOpened = false;
  errors = [3442, 3443];

  constructor(protected dialog: MatDialog) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        const errorCode = error?.error?.code;
        const errorInfo = error?.error?.info;

        if (this.errors.includes(errorCode) && !this.isOpened) {
          this.isOpened = true;
          if (errorCode === 3442) {
            this.companyService.info().subscribe((info) => {
              const instance = this.dialog.open(MessageDialogComponent, { disableClose: true, width: "350px" });
              instance.componentRef.setInput("title", `SERVER_ERROR_TITLE.${errorCode}`);
              instance.componentRef.setInput("message", `SERVER_ERROR.${errorCode}`);
              instance.componentRef.setInput(
                "secondMessage",
                this.translateService.instant("SERVER_ERROR.VERSION_INFO", {
                  version: info.sys_config.platform_versions?.backoffice,
                }),
              );
            });
          } else {
            const instance = this.dialog.open(MessageDialogComponent, { disableClose: true, width: "350px" });
            instance.componentRef.setInput("title", `SERVER_ERROR_TITLE.${errorCode}`);
            instance.componentRef.setInput("message", `SERVER_ERROR.${errorCode}`);
            instance.afterClosed().subscribe(() => (this.isOpened = false));
          }
        }

        return throwError(error);
      }),
    );
  }
}
